import React, { Suspense } from 'react';

import { Body } from './ui';

export const Mebiconn = () => {
  return (
    <Suspense>
      <Body />
    </Suspense>
  );
};
